import * as React from 'react';
import { useDispatch } from 'react-redux';
import { TThunkDispatch } from '../../../types/redux';
import { EStepCode, TNextStep } from '../../../types/form';
import { ISubmitProps, THandleFormSubmit } from '../types/internal';

const isQuizCompleted = (nextStep: TNextStep) => nextStep.nextStepCode === EStepCode.FormSent;

export const useQuizCompleteControls = (handleSubmit: THandleFormSubmit) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const [quizCompleted, _setQuizCompleted] = React.useState(false);
  const [quizSubmitting, _setQuizSubmitting] = React.useState(false);

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const [quizSubmitError, _setQuizSubmitError] = React.useState<string | null>(null);

  const handleCompleteQuiz = React.useCallback(
    async (props: ISubmitProps) => {
      _setQuizSubmitting(true);
      _setQuizSubmitError(null);

      const res = await dispatch(handleSubmit(props));

      if (res instanceof Error) {
        _setQuizSubmitError(res.message);
        _setQuizSubmitting(false);
        throw res;
      } else {
        _setQuizCompleted(true);
        _setQuizSubmitting(false);
      }
    },
    [_setQuizCompleted, handleSubmit, dispatch],
  );

  return { quizCompleted, handleCompleteQuiz, isQuizCompleted, quizSubmitError, quizSubmitting };
};
